import React, { useEffect, useState } from 'react';
import { Modal, ModalCancelButton, ModalConfirmButton } from '../Modal';
import { useMutation } from '@tanstack/react-query';
import { Toaster } from '../../helpers/toaster';
import { refetchQuery } from '../../helpers/events';
import { CONFIRM_MODAL } from '../../helpers/globalConstants';

const initialState = {
  message: 'Are you sure you want to delete this record ?',
  title: 'Please confirm',
  show: false,
  handleClose: () => {},
  refetchQueryKey: '',
  mutationFn: () => {},
  apiPayload: null,
};
export const ConfirmModal = () => {
  const [state, setState] = useState(initialState);

  const {
    message,
    title,
    show,
    handleClose,
    refetchQueryKey = '',
    mutationFn,
    apiPayload,
    confirmCb,
    cancelCb,
  } = state;

  const handleEvent = ({ detail }) => {
    setState((prev) => {
      return {
        ...prev,
        message: detail?.message ?? prev.message,
        title: detail?.title ?? prev.title,
        show: true,
        refetchQueryKey: detail?.refetchQueryKey,
        handleClose: detail?.handleClose ?? prev.handleClose,
        mutationFn: detail?.mutationFn ?? prev.mutationFn,
        apiPayload: detail?.apiPayload ?? prev.apiPayload,
        confirmCb: detail?.confirmCb,
        cancelCb: detail?.cancelCb,
      };
    });
  };
  const resetState = () => setState(initialState);
  const { mutate, isPending } = useMutation({
    mutationKey: mutationFn.name || 'mutationKey',
    mutationFn: mutationFn || '',
    onSuccess: (response) => {
      const body = response?.data;
      Toaster.success(body?.data?.[0]?.msg || 'Success');
      if (confirmCb) {
        // Handed the response body, for the callers that have something to
        // show from what the save worked out. The rest take no argument.
        confirmCb(body);
      }
      resetState();
      handleClose();
      if (refetchQueryKey)
        document.dispatchEvent(refetchQuery(refetchQueryKey));
    },
    onError: (error) => {
      resetState();
    },
  });

  // registering event for delete a record confirm modal
  useEffect(() => {
    document.addEventListener(CONFIRM_MODAL, handleEvent);
    return () => {
      document.removeEventListener(CONFIRM_MODAL, handleEvent);
    };
  }, []);

  return (
    <>
      {show ? (
        <Modal
          shouldCloseOnClickOutside={true}
          title={title}
          handleClose={resetState}
          width="sm"
          height="250"
          footerComponent={
            <div className="gap--sm d--flex w--full">
              <ModalCancelButton
                cb={() => {
                  if (cancelCb) {
                    cancelCb();
                  }
                  resetState();
                }}
              />
              {/* <ModalCancelButton cb={() => setshow(false)} /> */}
              <ModalConfirmButton
                cb={() => {
                  mutate(apiPayload ?? {});
                }}
                label={isPending ? 'Please wait...' : 'OK'}
                variant="success"
              />
            </div>
          }
        >
          {message}
        </Modal>
      ) : (
        <></>
      )}
    </>
  );
};
